import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import axios from "axios";

Vue.use(Router);
let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      props: true,
      component: () => import("./components/Common/appHome2"),
      meta: {
        requiresAuth: false,
        isClient: true,
        isSeller: false,
      },
      // {
      //     path: '/appHome2',
      //     props: true,
      //     component: () =>
      //         import ('./components/Common/appHome2'),
      //     meta: {
      //         requiresAuth: false,
      //         isClient: true,
      //         isSeller: false,
      //     },
      children: [
        // {
        // path: '',
        // name: 'Home',
        // meta: {
        //     requiresAuth: false,
        //     isClient: true,
        //     isSeller: false,
        // },
        // component: () =>
        //     import ('./components/Home/home')
        // },
        {
          path: "",
          name: "Login",
          props: true,
          component: () => import("./components/Common/appLogin"),
          meta: {
            requiresAuth: false,
            isClient: true,
            isSeller: true,
          },
        },
        {
          path: "product",
          name: "product",
          meta: {
            requiresAuth: false,
            isClient: true,
            isSeller: false,
          },
          component: () => import("./components/viewProduct/product"),
        },
      ],
    },

    {
      path: "/Login",
      name: "Login",
      props: true,
      component: () => import("./components/Common/appLogin"),
      meta: {
        requiresAuth: false,
        isClient: true,
        isSeller: true,
      },
    },
    {
      path: "/completeRegistration",
      name: "completeRegistration",
      meta: {
        requiresAuth: true,
        isClient: false,
        isSeller: true,
      },
      component: () => import("./components/completeProfile/completeProfile"),
    },
    {
      path: "/Products",
      component: () => import("./components/Common/appDashboard"),
      meta: {
        requiresAuth: false,
        isClient: true,
        isSeller: true,
      },
      children: [
        {
          path: "",
          name: "Products",
          meta: {
            isClient: true,
            isSeller: false,
          },
          component: () => import("./components/Products/products"),
        },
        {
          path: ":productname/:id",
          props: true,
          meta: {
            label: "Product",
            isClient: true,
            isSeller: false,
          },
          name: "Product Page",
          component: () => import("./components/Common/appProduct"),
        },
        // {
        //     path: '/Cart',
        //     name: 'Cart',
        //     meta: {
        //         requiresAuth: false,
        //         isClient: true,
        //         isSeller: false,
        //     },
        //     component: () =>
        //         import ('./components/Cart/cart'),
        // },
        // {
        //     path: '/Cart/Address',
        //     name: 'CartAddress',
        //     meta: {
        //         requiresAuth: true,
        //         isClient: true,
        //         isSeller: false,
        //     },
        //     component: () =>
        //         import ('./components/Cart/address'),
        // },
        // {
        //     path: '/Wishlist',
        //     name: 'Wishlist',
        //     meta: {
        //         requiresAuth: true,
        //         isClient: true,
        //         isSeller: false,
        //     },
        //     component: () =>
        //         import ('./components/Wishlist/wishlist'),
        // },
        {
          path: "/Orders",
          meta: {
            requiresAuth: true,
            isClient: true,
            isSeller: false,
          },

          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Orders",
              meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
              },
              component: () => import("./components/Orders/orders"),
            },
            {
              path: ":id",
              name: "MyOrderDetails",
              meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
              },
              component: () => import("./components/Orders/order"),
            },
          ],
        },

        
        {
          path: "/Profile",
          meta: {
            label: "Profile",
            requiresAuth: true,
            isClient: true,
            isSeller: true,
          },
          component: () => import("./components/Profile/profile"),
          children: [
            {
              path: "",
              name: "Profile",
              meta: {
                label: "Profile",
                requiresAuth: true,
                isClient: true,
                isSeller: true,
              },
              component: () => import("./components/Profile/profileDetails"),
            },
            {
              path: "Edit",
              name: "Edit Profile",
              meta: {
                label: "Edit Profile",
                requiresAuth: true,
                isClient: true,
                isSeller: true,
              },
              component: () => import("./components/Profile/editProfile"),
            },
            {
              path: "Orders",
              name: "Profle Orders",
              meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
              },
              component: () => import("./components/Profile/orders"),
            },
            {
              path: "Wishlist",
              name: "Profile Wishlist",
              meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
              },
              component: () => import("./components/Profile/wishlist"),
            },
            {
              path: "Cart",
              name: "Profile Cart",
              meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
              },
              component: () => import("./components/Profile/cart"),
            },
            {
              path: "SavedAddress",
              name: "SavedAddress",
              meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
              },
              component: () => import("./components/Profile/savedAddress"),
            },
          ],
        },
      ],
    },
    // {
    //     path: '/Shops',
    //     meta: {
    //         label: 'Shops',
    //         isClient: true,
    //         isSeller: false,
    //     },
    //     component: {
    //         render(c) { return c('router-view') }
    //     },
    //     children: [{
    //             path: '',
    //             name: 'Shops',
    //             component: () =>
    //                 import ('./components/Shops/shops'),
    //         },
    //         {
    //             path: 'Offers/:id',
    //             props: true,
    //             name: 'ShopOffers',
    //             meta: {
    //                 isClient: true,
    //                 isSeller: false,
    //             },
    //             component: () =>
    //                 import ('./components/Shops/offers'),
    //         },
    //         {
    //             path: 'NewProducts/:id',
    //             props: true,
    //             name: 'NewProducts',
    //             meta: {
    //                 isClient: true,
    //                 isSeller: false,
    //             },
    //             component: () =>
    //                 import ('./components/Shops/newProducts'),
    //         },
    //         {
    //             path: ':id/:shopname',
    //             props: true,
    //             name: 'Shop',
    //             meta: {
    //                 isClient: true,
    //                 isSeller: false,
    //             },
    //             component: () =>
    //                 import ('./components/Shops/shop'),
    //         },
    //     ]
    // },
    // {
    //     path: '/Deals',
    //     meta: {
    //         label: 'Deals',
    //         isClient: true,
    //         isSeller: false,
    //     },
    //     component: {
    //         render(c) { return c('router-view') }
    //     },
    //     children: [{
    //             path: '',
    //             name: 'AllDeals',
    //             component: () =>
    //                 import ('./components/Deals/deals'),
    //         },
    //         {
    //             path: 'BuyNGetMFree/:id',
    //             props: true,
    //             name: 'BuyNGetMFree',
    //             meta: {
    //                 isClient: true,
    //                 isSeller: false,
    //             },
    //             component: () =>
    //                 import ('./components/Deals/buyNGetMFree'),
    //         },
    //         {
    //             path: 'BuyNGetMOff/:id',
    //             props: true,
    //             name: 'BuyNGetMOff',
    //             meta: {
    //                 isClient: true,
    //                 isSeller: false,
    //             },
    //             component: () =>
    //                 import ('./components/Deals/buyNGetMOff'),
    //         },
    //         {
    //             path: 'Address/:id',
    //             name: 'DealAddress',
    //             props: true,
    //             meta: {
    //                 requiresAuth: true,
    //                 isClient: true,
    //                 isSeller: false,
    //             },
    //             component: () =>
    //                 import ('./components/Deals/Deal/address'),
    //         },
    //         {
    //             path: 'BuyNGetMOff/Address/:id',
    //             name: 'BuyNGetMOffDealAddress',
    //             props: true,
    //             meta: {
    //                 requiresAuth: true,
    //                 isClient: true,
    //                 isSeller: false,
    //             },
    //             component: () =>
    //                 import ('./components/Deals/Deal2/address'),
    //         },
    //     ]
    // },

    {
      path: "/sellerRegistration",
      name: "SellerRegistration",
      meta: {
        requiresAuth: true,
        isClient: false,
        isSeller: true,
      },
      component: () => import("./components/Login/sellerRegistration"),
    },
    {
      path: "/sellerStatus",
      name: "sellerStatus",
      component: () => import("./components/Login/sellerStatus"),
      props: true,
      meta: {
        requiresAuth: true,
        isClient: false,
        isSeller: true,
      },
    },
    {
      path: "/Seller",
      meta: {
        requiresAuth: true,
        isClient: false,
        isSeller: true,
      },
      component: () => import("./components/Common/appSellerDashboard"),
      children: [
        {
          path: "",
          name: "Seller",
          component: () => import("./components/Seller/Analytics/analytics"),
        },
        {
          path: "StockView",
          name: "StockView",
          component: () => import("./components/Seller/StockView/allinventory"),
        },
        {
          path: "Inventory",
          name: "Inventory",
          component: () => import("./components/Seller/Inventory/inventory"),
        },
        {
          path: "AddProduct",
          name: "AddProduct",
          component: () => import("./components/Seller/Product/addProduct"),
        },
        {
          path: "ProductOrder/:id",
          name: "SellerProductDetails",
          props: true,
          component: () =>
            import("./components/Seller/ProductOrderDetails/product"),
        },
        {
          path: "Product/:id",
          name: "SellerProductDetails",
          props: true,
          component: () => import("./components/Seller/ProductDetails/product"),
        },
        {
          path: "Reviews/",
          name: "Reviews",
          // props: true,
          component: () => import("./components/Seller/ProductDetails/reviews"),
        },
        {
          path: "Product/Edit/:id",
          name: "EditProduct",
          props: true,
          component: () => import("./components/Seller/Product/editProduct"),
        },
        {
          path: "Product/:status/:id",
          name: "ProductStatus",
          props: true,
          component: () => import("./components/Seller/Product/productStatus"),
        },
        {
          path: "SoldProducts",
          name: "SoldProducts",
          component: () =>
            import("./components/Seller/SoldProducts/soldProducts"),
        },
        {
          path: "PendingOrders",
          name: "PendingOrders",
          component: () =>
            import("./components/Seller/PendingOrders/pendingOrders"),
        },
        {
          path: "CancelledOrders",
          name: "CancelledOrders",
          component: () =>
            import("./components/Seller/CancelledOrders/cancelledOrders"),
        },
        {
          path: "Orders/:id",
          name: "OrderDetails",
          props: true,
          component: () => import("./components/Seller/Order/order"),
        },
        {
          path: "Offers",
          name: "Offers",
          component: () => import("./components/Seller/Offers/offers"),
        },
        {
          path: "Offers/Add",
          name: "AddOffer",
          props: true,
          component: () => import("./components/Seller/Offers/addOffer"),
        },
        {
          path: "Deals",
          name: "Deals",
          component: () => import("./components/Seller/Deals/deals"),
        },
        {
          path: "Deals/Add/:id",
          name: "AddDeal",
          props: true,
          component: () => import("./components/Seller/Deals/addDeal"),
        },

        {
          path: "Profile",
          name: "SellerProfile",
          component: () => import("./components/Seller/Profile/userProfile"),
          props: true,
        },
        {
          path: "Search",
          name: "Search",
          component: () => import("./components/Seller/Search/search"),
          props: true,
        },
        {
          path: "Notification",
          name: "Notification",
          // props: true,
          component: () => import("./components/Notification/notification"),
        },
      ],
    },
    // {
    //     path: '/Payment/status',
    //     name: 'PaymentStatus',
    //     props: true,
    //     component: () =>
    //         import ('./components/Payment/status'),
    //     meta: {
    //         requiresAuth: true,
    //         isClient: true,
    //         isSeller: true,
    //     }
    // },
    // {
    //     path: '/Payment/success',
    //     name: 'PaymentSuccess',
    //     props: true,
    //     component: () =>
    //         import ('./components/Payment/success'),
    //     meta: {
    //         requiresAuth: true,
    //         isClient: true,
    //         isSeller: true,
    //     }
    // },
    // {
    //     path: '/Payment/error',
    //     name: 'PaymentError',
    //     props: true,
    //     component: () =>
    //         import ('./components/Payment/error'),
    //     meta: {
    //         requiresAuth: true,
    //         isClient: true,
    //         isSeller: true,
    //     }
    // },
    // {
    //     path: '/Payment/processing',
    //     name: 'PaymentProcessing',
    //     props: true,
    //     component: () =>
    //         import ('./components/Payment/processing'),
    //     meta: {
    //         requiresAuth: true,
    //         isClient: true,
    //         isSeller: true,
    //     }
    // },
    {
      path: "/Page/:id",
      name: "GeneralPage",
      props: true,
      component: () => import("./components/GeneralPages/generalPage"),
      meta: {
        requiresAuth: false,
        isClient: true,
        isSeller: true,
      },
    },
    {
      path: "/blog",
      name: "Blog",
      component: () => import("./components/GeneralPages/blog"),
      meta: {
        requiresAuth: false,
        isClient: true,
        isSeller: true,
      },
    },
    {
      path: "/blogDetails",
      name: "BlogDetails",
      props: true,
      component: () => import("./components/GeneralPages/blogDetails"),
      meta: {
        requiresAuth: false,
        isClient: true,
        isSeller: true,
      },
    },
    {
      path: "/ServerError",
      name: "ServerError",
      props: true,
      component: () => import("./components/Common/500"),
      meta: {
        requiresAuth: false,
        isClient: true,
        isSeller: true,
      },
    },
    {
      path: "*",
      name: "404PageNotFound",
      props: true,
      component: () => import("./components/Common/404"),
      meta: {
        requiresAuth: false,
        isClient: true,
        isSeller: true,
      },
    },
  ],
  scrollBehavior() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  },
});
// store.state.isLoggedIn == true  || to.matched.some(route => route.meta.requiresAuth == true)
router.beforeEach((to, from, next) => {
  if (to.fullPath !== "/Login") {
    localStorage.setItem("routeKey", to.fullPath);
  }
  if (
    store.state.isLoggedIn == true ||
    to.matched.some((route) => route.meta.requiresAuth == true)
  ) {
    axios({
      method: "POST",
      url: "/authenticate/user",
      headers: {
        token: localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (!response.data.status) {
          store.commit("sessionOut", true);
          return;
        }
      })
      .catch((err) => {
        var msg = err;
        console.log(msg);
      });
  }

  if (
    to.path == "/Seller" &&
    store.state.isLoggedIn == true &&
    store.state.userType == "customer"
  ) {
    next({ name: "Login" });
    return;
  }
  if (
    localStorage.getItem("profStat") == "active" &&
    store.state.userType === "seller"
  ) {
    if (
      to.path == "/" ||
      (to.path == "/Login" &&
        store.state.isLoggedIn == true &&
        store.state.userType === "seller")
    ) {
      next({ name: "Seller" });
      return;
    }
  }
  if (
    localStorage.getItem("profStat") == "incomplete" &&
    store.state.userType === "seller"
  ) {
    if (
      to.path == "/" ||
      to.path == "/Seller" ||
      (to.path == "/Login" &&
        store.state.isLoggedIn == true &&
        store.state.userType === "seller")
    ) {
      next({ name: "completeRegistration" });
      return;
    }
  }
  
  if (
    localStorage.getItem("profStat") == "pending" &&
    store.state.userType === "seller"
  ) {
    if (
      to.path == "/" ||
      to.path == "/Seller" ||
      (to.path == "/Login" &&
        store.state.isLoggedIn == true &&
        store.state.userType === "seller")
    ) {
      next({ name: "completeRegistration" });
      return;
    }
  }
  
  if (
    localStorage.getItem("profStat") == "reject" &&
    store.state.userType === "seller"
  ) {
    if (
      to.path == "/" ||
      to.path == "/Seller" ||
      (to.path == "/Login" &&
        store.state.isLoggedIn == true &&
        store.state.userType === "seller")
    ) {
      next({ name: "sellerStatus" });
      return;
    }
  }

  // if (
  //   to.name == "Login" &&
  //   store.state.isLoggedIn == true &&
  //   store.state.userType === "seller" &&
  //   localStorage.getItem("profStat") == "active"
  // ) {
  //   console.log("Active mine");
  //   next({ name: "Seller" });
  //   return;
  // }
  // if (
  //   to.matched.some((route) => route.meta.isSeller == false) &&
  //   store.state.isLoggedIn == true &&
  //   store.state.userType == "seller" &&
  //   localStorage.getItem("profStat") == "active"
  // ) {
  //   next({ name: "Seller" });
  //   return;
  // }
  // if (
  //   to.path == "/Seller" &&
  //   store.state.isLoggedIn == true &&
  //   store.state.userType == "seller" &&
  //   localStorage.getItem("profStat") == "pending"
  // ) {
  //   next({ name: "sellerStatus" });
  //   return;
  // }
  // if (
  //   to.path == "/Seller" ||
  //   to.path == "/" &&
  //   store.state.isLoggedIn == true &&
  //   store.state.userType === "seller" &&
  //   localStorage.getItem("profStat") == "incomplete"
  // ) {
  //   console.log("incomplete seller");
  //   next({ name: "completeRegistration" });
  //   return;
  // }

  // if (
  //   to.name == "Seller" &&
  //   store.state.isLoggedIn == true &&
  //   store.state.userType == "seller" &&
  //   localStorage.getItem("profStat") == "reject"
  // ) {
  //   console.log("rehjected okk");
  //   return;
  // }
  // if ( store.state.isLoggedIn == true && (store.state.userType == 'seller') && (store.state.userDetailed.profileStatus == 'reject')) {
  //     next({ name: 'sellerStatus' })
  //     this.$router.push('/sellerStatus')
  //     return
  // }

  next();
});

export default router;
